import React from 'react';
import Footer from '../Footer';
import Header from '../Header';
import Newsletter from '../Newsletter';
import Service from '../Service';

const Service2 = () => {
  return (
    <>

    <Header />
    <Service/>
    <Newsletter />
    <Footer />

      
    </>
  )
}

export default Service2
